import * as React from "react";

import GlobalState from "@sentrei/common/models/GlobalState";
import {SnackbarEmitter} from "@sentrei/common/utils/snackbar";

const GlobalContext = React.createContext<GlobalState>({
  snackbar: SnackbarEmitter,
});

export default GlobalContext;
